import { render, staticRenderFns } from "./OurAwards.vue?vue&type=template&id=06fc0606&scoped=true&"
import script from "./OurAwards.vue?vue&type=script&lang=js&"
export * from "./OurAwards.vue?vue&type=script&lang=js&"
import style0 from "./OurAwards.vue?vue&type=style&index=0&id=06fc0606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fc0606",
  null
  
)

export default component.exports